import React, { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Input } from 'antd'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'

const MenuIdFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const { menuId } = getQueryParams(search)
  const [value, setValue] = useState(menuId)

  const onSearch = useCallback(
    menuId => {
      history.push(
        createUrl(pathname, search, {
          menuId,
        }),
      )
    },
    [history, pathname, search],
  )

  return (
    <Form.Item
      label="Menu ID"
      colon={false}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Input.Search
        value={value}
        onChange={({ target: { value } }) => setValue(value)}
        onSearch={onSearch}
        allowClear
      />
    </Form.Item>
  )
}

export default MenuIdFilter
